import { useEffect } from "react";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import GuardianDonationWidget from "@/components/donation/GuardianDonationWidget";
import { setMetaTag } from "@/lib/seo";
import { CANONICAL_URL } from "@/lib/api";

export default function Donate() {
  useEffect(() => {
    document.title = "Become a Guardian | AMTM Rescue Hub";
    setMetaTag("og:title", "Become a Guardian | AMTM Rescue Hub");
    setMetaTag("og:description", "Give monthly so AMTM can plan ahead, keep our vets, and never turn away an emergency.");
    setMetaTag("og:image", `${CANONICAL_URL}/images/sanctuary.jpg`);
  }, []);

  return (
    <div className="min-h-screen bg-amtm-bg" data-testid="donate-page">
      <PublicHeader />
      <section className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-24 grid md:grid-cols-2 gap-12 items-start">
        <div>
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-amtm-teal mb-5">
            AMTM Guardians
          </p>
          <h1 className="font-display text-4xl md:text-5xl leading-tight text-amtm-text mb-5" data-testid="donate-page-headline">
            Would you like to become one of the people who keeps 500+ rescued animals alive every single day?
          </h1>
          <p className="text-base md:text-lg text-amtm-textMuted leading-relaxed">
            AMTM Guardians give monthly, so we can plan ahead, keep our vets, and never turn away an emergency.
          </p>
        </div>
        <GuardianDonationWidget />
      </section>
      <PublicFooter />
    </div>
  );
}
